export enum CharacterFrame {
    DOWN_DIRECTION = 0,
    LEFT_DIRECTION = 1,
    RIGHT_DIRECTION = 2,
    UP_DIRECTION = 3
}